"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var hydroWallet_1 = __importDefault(require("./hydroWallet"));
exports.HydroWallet = hydroWallet_1.default;
var extensionWallet_1 = __importDefault(require("./extensionWallet"));
exports.ExtensionWallet = extensionWallet_1.default;
var coinbaseWallet_1 = __importDefault(require("./coinbaseWallet"));
exports.CoinbaseWallet = coinbaseWallet_1.default;
var centralizedWallet_1 = __importDefault(require("./centralizedWallet"));
exports.CentralizedWallet = centralizedWallet_1.default;
var baseWallet_1 = __importDefault(require("./baseWallet"));
exports.BaseWallet = baseWallet_1.default;
var hardwareWallet_1 = __importDefault(require("./hardwareWallet"));
exports.HardwareWallet = hardwareWallet_1.default;
var walletConnectWallet_1 = __importDefault(require("./walletConnectWallet"));
exports.WalletConnectWallet = walletConnectWallet_1.default;
var ledger_1 = __importDefault(require("./ledger"));
exports.Ledger = ledger_1.default;
var dcent_1 = __importDefault(require("./dcent"));
exports.Dcent = dcent_1.default;
var fortmatic_1 = __importDefault(require("./fortmatic"));
exports.Fortmatic = fortmatic_1.default;
var trezor_1 = __importDefault(require("./trezor"));
exports.Trezor = trezor_1.default;
var utils_1 = require("ethers/utils");
var ethers_1 = require("ethers");
var providers_1 = require("ethers/providers");
var axios_1 = __importDefault(require("axios"));
var NeedUnlockWalletError = baseWallet_1.default.NeedUnlockWalletError, NotSupportedError = baseWallet_1.default.NotSupportedError;
exports.NeedUnlockWalletError = NeedUnlockWalletError;
exports.NotSupportedError = NotSupportedError;
exports.globalNodeUrl = "https://api.cypress.klaytn.net:8651";
exports.payloadId = function () {
    var datePart = new Date().getTime() * Math.pow(10, 3);
    var extraPart = Math.floor(Math.random() * Math.pow(10, 3));
    return datePart + extraPart;
};
exports.setGlobalNodeUrl = function (nodeUrl) {
    if (nodeUrl) {
        exports.globalNodeUrl = nodeUrl;
    }
};
exports.truncateAddress = function (address) {
    return address.slice(0, 6) + "..." + address.slice(-4);
};
exports.getNetworkID = function () {
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1.default.post(exports.globalNodeUrl, {
                        "jsonrpc": "2.0",
                        "method": "net_version",
                        "params": [],
                        "id": exports.payloadId()
                    })];
                case 1:
                    result = _a.sent();
                    if (result.data.error !== undefined) {
                        reject(result.data.error);
                    }
                    else if (result.data.result !== undefined) {
                        resolve(result.data.result);
                    }
                    else {
                        resolve(parseInt(result.data.result, 10));
                    }
                    return [2];
            }
        });
    }); });
};
exports.sendRawTransaction = function (data) {
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1.default.post(exports.globalNodeUrl, {
                        "jsonrpc": "2.0",
                        "method": "klay_sendRawTransaction",
                        "params": [data],
                        "id": exports.payloadId()
                    })];
                case 1:
                    result = _a.sent();
                    if (result.data.error !== undefined) {
                        reject(result.data.error);
                    }
                    else if (result.data.result !== undefined) {
                        resolve(result.data.result);
                    }
                    else {
                        reject(new Error("Unknown Error"));
                    }
                    return [2];
            }
        });
    }); });
};
exports.getBalance = function (address) {
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1.default.post(exports.globalNodeUrl, {
                        "jsonrpc": "2.0",
                        "method": "klay_getBalance",
                        "params": [address, "latest"],
                        "id": exports.payloadId()
                    })];
                case 1:
                    result = _a.sent();
                    if (result.data.error !== undefined) {
                        reject(result.data.error);
                    }
                    else if (result.data.result !== undefined) {
                        resolve(new utils_1.BigNumber(result.data.result || 0));
                    }
                    else {
                        reject(new Error("Unknown Error"));
                    }
                    return [2];
            }
        });
    }); });
};
exports.getTransactionReceipt = function (txID) {
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1.default.post(exports.globalNodeUrl, {
                        "jsonrpc": "2.0",
                        "method": "klay_getTransactionReceipt",
                        "params": [txID],
                        "id": exports.payloadId()
                    })];
                case 1:
                    result = _a.sent();
                    if (result.data.error !== undefined) {
                        reject(result.data.error);
                    }
                    else if (result.data.result !== undefined) {
                        resolve(result.data.result);
                    }
                    else {
                        reject(new Error("Unknown Error"));
                    }
                    return [2];
            }
        });
    }); });
};
exports.getEstimateGas = function (params) {
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1.default.post(exports.globalNodeUrl, {
                        "jsonrpc": "2.0",
                        "method": "klay_estimateGas",
                        "params": [JSON.stringify(params)],
                        "id": exports.payloadId()
                    })];
                case 1:
                    result = _a.sent();
                    if (result.data.error !== undefined) {
                        reject(result.data.error);
                    }
                    else if (result.data.result !== undefined) {
                        resolve(result.data.result);
                    }
                    else {
                        reject(new Error("Unknown Error"));
                    }
                    return [2];
            }
        });
    }); });
};
exports.getTransactionCount = function (address, status) {
    if (status === void 0) { status = "latest"; }
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1.default.post(exports.globalNodeUrl, {
                        "jsonrpc": "2.0",
                        "method": "klay_getTransactionCount",
                        "params": [address, status],
                        "id": exports.payloadId()
                    })];
                case 1:
                    result = _a.sent();
                    if (result.data.error !== undefined) {
                        reject(result.data.error);
                    }
                    else if (result.data.result !== undefined) {
                        resolve(Number(result.data.result));
                    }
                    else {
                        reject(new Error("Unknown Error"));
                    }
                    return [2];
            }
        });
    }); });
};
exports.getContract = function (contractAddress, abi) {
    var provider = new providers_1.JsonRpcProvider(exports.globalNodeUrl);
    return new ethers_1.Contract(contractAddress, abi, provider);
};
exports.defaultWalletTypes = [extensionWallet_1.default.TYPE, hydroWallet_1.default.TYPE, walletConnectWallet_1.default.TYPE, centralizedWallet_1.default.TYPE];
exports.needConnectWalletTypes = [dcent_1.default.TYPE, coinbaseWallet_1.default.TYPE, fortmatic_1.default.TYPE, walletConnectWallet_1.default.TYPE, centralizedWallet_1.default.TYPE];
